module.exports = __webpack_public_path__ + "static/media/sub-mileage.d3c82f1c.svg";